module.exports = __webpack_public_path__ + "static/media/refer-logo.74834f1b.svg";